import { render, staticRenderFns } from "./PhoneCompleteView.vue?vue&type=template&id=2838b278&scoped=true&"
import script from "./PhoneCompleteView.vue?vue&type=script&lang=js&"
export * from "./PhoneCompleteView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2838b278",
  null
  
)

export default component.exports